import styled, { css } from "styled-components";
import { FooterLinkItemProps, InputProps } from "./FormModal.types";
import { pxToRem, withAlpha } from "styles/utils";
import { Input as SharedInput } from "../../IOSCompatibleInput/IOSCompatibleInput.style";
import { ModalSurfaceBase } from "../ModalPrimitives";

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  background: ${({ theme }) => withAlpha(theme.colors.black, 0.5)};
`;

export const ModalWrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)};
  pointer-events: none;
`;

export const FormWrapper = styled(ModalSurfaceBase)`
  width: min(100%, ${pxToRem(441)});
  padding: ${({ theme }) => pxToRem(theme.spacing.xxl)};
  text-align: center;
  pointer-events: auto;

  h2 {
    margin: 0 0 ${({ theme }) => pxToRem(theme.spacing.xl)};
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
    font-weight: 600;
    line-height: 1.25;
  }
`;

export const FieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.md)};
  text-align: left;
`;

export const Input = styled(SharedInput)<InputProps>`
  height: ${({ height, theme }) => pxToRem(height || theme.controlHeight.md)};
`;

export const ErrorMessage = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  line-height: 1.35;
`;

export const FooterLinksWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.md)};
`;

export const FooterLinkItem = styled.a<FooterLinkItemProps>`
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 500;
  text-decoration: none;

  ${({ variant, theme }) =>
    variant === "primary" &&
    css`
      color: ${theme.colors.brandSoftAlt};
    `}

  ${({ variant, theme }) =>
    variant === "secondary" &&
    css`
      color: ${theme.colors.inkMuted};
    `}

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;

export const PasswordToggle = styled.button`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
  height: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
  padding: 0;
  border: 0;
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkMuted};
  cursor: pointer;
  transform: translateY(-50%);

  &:hover {
    background: ${({ theme }) => theme.colors.inkSurface};
    color: ${({ theme }) => theme.colors.ink};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(1)};
  }
`;

export const PasswordIcon = styled.svg`
  width: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  height: ${({ theme }) => pxToRem(theme.fontSize.xl)};
  flex: 0 0 auto;
`;
